/**
 * OptionsDialog - Wrapper component for options menu using Dialog
 */

import type { Component, ReactNode } from 'react';
import Dialog from './Dialog';

// React is available globally from CDN
const React = (window as any).React;
const ReactComponent = React.Component;

interface OptionsDialogProps {
    onClose: () => void;
    children: ReactNode;
}

class OptionsDialog extends ReactComponent<OptionsDialogProps> {
    render(): ReactNode {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) {
            return null;
        }

        return React.createElement(DialogComponent, {
            title: 'Options',
            onClose: this.props.onClose,
            actionButtons: React.createElement('button', {
                className: 'btn close-btn',
                onClick: this.props.onClose
            }, 'Close'),
            closeOnBackdropClick: false // Has action buttons, so don't close on backdrop click
        }, this.props.children);
    }
}

(window as any).OptionsDialog = OptionsDialog;
export default OptionsDialog;
